module.exports = __webpack_public_path__ + "img/add.ca3efbf7.svg";